<template>
  <div id="candle-show">
    <disabled-overlay />
    <profile-module />
    <b-col>
      <h1 class="title">{{ $t('pages.candle.title') }}</h1>
    </b-col>
    <e-index
      :uri="$helper.getUri('candle')"
      :modal-uri-create="`api/public/memorial/${id}/candle`"
      :modal-uri="`api/memorial/${id}/candle`"
      :order-call-back="orderCallBack"
      :can-manage="$root.canManage()"
      :can-create="!$root.isDemo() || $root.canManage()"
      :mosaic-cols="4"
      name="candle"
      mode="mosaic"
    >
      <div slot="mosaic-content" slot-scope="ctx">
        <div
          v-if="ctx.item.image !== null"
          :style="`background-image:url(${$helper.imageUrl(ctx.item.image.file_url, true)})`"
          class="thumbnail clickable"
          @click="openModal(modalName('image'), ctx.item)"
        >
          <i class="ti ti-fw ti-2x ti-search" />
          <div class="text">{{ $helper.demoFallbackTranslation(ctx.item, 'text') }}</div>
        </div>
        <contact-entity :contact="ctx.item.contact" />
      </div>
    </e-index>
    <e-modal :event-id="modalName('image')" class="image-modal has-navigate">
      <navigate :item="candle" name="candle" />
      <div class="candle-content">
        <div class="text">{{ $helper.demoFallbackTranslation(candle, 'text') }}</div>
        <img v-if="candle.image" :src="$helper.imageUrl(candle.image.file_url)" class="img-fluid">
      </div>
    </e-modal>
  </div>
</template>

<script>
  import EModal from '@/components/EModal';
  import EIndex from '@/components/EIndex';
  import ProfileModule from '@/components/ProfileModule';
  import DisabledOverlay from '@/components/DisabledOverlay';
  import Navigate from '@/components/Navigate';
  import ContactEntity from '@/components/ContactEntity';
  import MemorialGuard from '@/mixins/MemorialGuard';

  export default {
    name: 'CandleIndex',
    components: {
      EIndex,
      EModal,
      ProfileModule,
      DisabledOverlay,
      Navigate,
      ContactEntity,
    },
    mixins: [
      MemorialGuard,
    ],
    props: {
      id: {
        type: [Number, String],
        default: null,
      },
    },
    data() {
      return {
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
        candle: {},
        candles: {},
      };
    },
    mounted() {
      this.$bus.$once(`t-event.t-modal.image-${this.uid}.closed`, () => {
        this.candle = {};
      });

      this.$bus.$on('t-event.ajax-index.load-data-success', (candles) => {
        this.candles = candles;
      });

      this.$bus.$on('t-event.navigate.success', (candle) => {
        this.candle = candle;
        this.addNextPrev(this.candle);
      });
    },
    methods: {
      addNextPrev(data) {
        const currentCandleKey = _.findIndex(this.candles, candle => candle.id === data.id);

        if (this.candles[currentCandleKey + 1]) {
          data.next = this._.omit(this.candles[currentCandleKey + 1], 'next', 'prev');
        }

        if (this.candles[currentCandleKey - 1]) {
          data.prev = this._.omit(this.candles[currentCandleKey - 1], 'next', 'prev');
        }

        return data;
      },
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        if (id === this.modalName('image')) {
          this.candle = this.addNextPrev(data);
        }
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
      orderCallBack(collection) {
        return _.orderBy(collection, ['created_at'], ['desc']);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .thumbnail {
    display: flex;
    align-items: center;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($black, .6);
    }

    .text {
      position: absolute;
      width: 100%;
      color: $white;
      z-index: 10;
    }
  }

  /deep/ .image-modal .sweet-content-content {
    .candle-content {
      display: flex;
      align-items: center;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba($black, .6);
      }

      .text {
        position: absolute;
        color: $white;
        font-weight: bold;
        margin: auto;
        text-align: center;
        width: 100%;
        font-size: 40px;
      }

      img.img-fluid {
        width: 100%;
      }
    }
  }

  /deep/ .modal-form {
   overflow: auto;

    .sweet-modal {
      margin-bottom: 25px;
    }
  }

  @include editable-max-width(600px) {
    .image-modal .sweet-content-content .candle-content .text {
      font-size: 18px;
      padding: 10px;
      word-break: break-all;
    }

    /deep/ .modal-form {
      .sweet-modal {
        top: $nav-height;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Candle/index.vue